import { getConfig } from '@klpkonsern/appconfig';
import type { IUser } from '@klp/user/interfaces';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_INTERCOM_APP_ID: string;
        WEBAPP_INTERCOM_ENABLE: boolean;
    }
}

export const updateUser = (user: IUser) => {
    if (!getConfig('WEBAPP_INTERCOM_ENABLE', false)) return;

    window['Intercom']('boot', {
        app_id: getConfig('WEBAPP_INTERCOM_APP_ID', ''),
        email: user.email,
        user_id: user.id,
        name: `${user.firstName} ${user.lastName}`,
        isAdmin: user.isAdmin,
        customers: user.customers?.join(','),
    });
};
